import { Button } from '@/ui';
import { Minus, Plus, RotateCcw } from 'lucide-react';

export const ViewerToolbar = ({
  zoom,
  onZoomOut,
  onZoomIn,
  onReset,
}: {
  zoom: number;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onReset: () => void;
}) => {
  return (
    <div
      data-no-pan
      className="pointer-events-auto absolute bottom-3 left-3 z-10 flex items-center overflow-hidden rounded-lg bg-black/50 shadow-sm backdrop-blur-sm"
    >
      <Button
        type="button"
        variant="headless"
        className="flex h-9 w-9 items-center justify-center text-steel-200 hover:bg-white/10 hover:text-steel-50"
        onClick={onZoomOut}
        aria-label="Zoom out"
      >
        <Minus className="size-4" />
      </Button>
      <div className="min-w-10 border-x border-white/10 px-2 text-center text-xs tabular-nums text-steel-200">
        {(zoom * 100).toFixed(0)}%
      </div>
      <Button
        type="button"
        variant="headless"
        className="flex h-9 w-9 items-center justify-center text-steel-200 hover:bg-white/10 hover:text-steel-50"
        onClick={onZoomIn}
        aria-label="Zoom in"
      >
        <Plus className="size-4" />
      </Button>
      <Button
        type="button"
        variant="headless"
        className="flex h-9 w-9 items-center justify-center text-steel-200 hover:bg-white/10 hover:text-steel-50"
        onClick={onReset}
        aria-label="Reset view"
      >
        <RotateCcw className="size-4" />
      </Button>
    </div>
  );
};
